"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _loading = require("./loading.styles");

var _spinner = _interopRequireDefault(require("./spinner"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  size: 'md',
  type: 'default'
};
const preClass = 'nextui-loading';

const Loading = ({
  children,
  size,
  gradientBackground,
  loadingCss,
  type,
  ...props
}) => {
  const ariaLabel = children ? '' : 'Loading';
  const loadingGradientCSS = (0, _react.useMemo)(() => {
    return type === 'gradient' ? {
      '._2': {
        bg: gradientBackground
      }
    } : {};
  }, [type]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_loading.StyledLoadingContainer, { ...props,
    children: type === 'spinner' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.default, {
      size: size,
      children: children
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_loading.StyledLoading, {
        className: `${preClass} ${preClass}-${type}`,
        css: { ...loadingCss,
          ...loadingGradientCSS
        },
        type: type,
        size: size,
        "aria-label": ariaLabel,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "_1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "_2"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          className: "_3"
        })]
      }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_loading.StyledLoadingLabel, {
        size: size,
        className: `${preClass}-label`,
        children: children
      })]
    })
  });
};

Loading.toString = () => '.nextui-loading';

const MemoLoading = /*#__PURE__*/_react.default.memo(Loading);

var _default = (0, _withDefaults.default)(MemoLoading, defaultProps);

exports.default = _default;
module.exports = exports.default;